<template>
  <div class="profit">
    <div class="profit-search">
      <div class="screen">
        <el-date-picker
          class="w240"
          v-model="screen.date"
          type="daterange"
          start-placeholder="开始结算"
          end-placeholder="结束结算"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          @blur="pickerBlur"
        >
        </el-date-picker>
        <el-select class="white w200" clearable v-model="screen.status" placeholder="请选择结算开票状态">
          <el-option
            v-for="item in statusList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select class="white w200" clearable v-model="screen.type" placeholder="请选择">
          <el-option
            v-for="item in typeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select class="white w200" clearable filterable v-model="screen.projectId" placeholder="请选择项目">
          <el-option
            v-for="item in projectList.filter(data => data.status)"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-button class="btn-blue" @click="onScreen">搜索</el-button>
      </div>
      
      <el-button
        class="btn-white"
        @click="downExcel"
      >
        导出
        </el-button
      >
    </div>
    
    <DropTable
      ref="profitTable"
      :columns="tableTitle"
      :data="tableData"
      tableKey="profitList"
      border
      :row-key="getKey"
    >
    </DropTable>

    <div class="footer">
      <pagination-tpl
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        :layout="layout"
        @queryChange="queryChange"
        @onSizeChange="onSizeChange"
      ></pagination-tpl>
    </div>

  </div>
</template>

<script>
import DropTable from "components/base/DropTable.vue";
import PaginationTpl from "components/base/PaginationTpl";
import { formatTimeToDate, modifyNetTitle, keepTwoDecimal } from "common/js/util";
import Profit from "models/profit";
import EnterExitWarehouseProjectMixins from 'common/mixins/enter-exit-warehouse-project'
export default {
  mixins: [EnterExitWarehouseProjectMixins],
  data() {
    return {
      screen: {
        projectId: null,
        status: 4,
        type: 1,
        date: [formatTimeToDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1)), formatTimeToDate(new Date())] // 当前月1号到今天
      },
      pickDate: '', // 存放getPickDate获取的数据
      pickerOptions: {
        onPick: this.getPickDate,
        // 限制日期
        disabledDate: this.disabledDate,
      },
      statusList: [
        {id:1, name: '已结算已开票'},
        {id:2, name: '已结算未开票'},
        {id:3, name: '未结算未开票'},
        {id:4, name: '全部'},
      ],
      typeList: [
        {id:1, name: '进仓'},
        {id:2, name: '出仓'}
      ],
      tableData: [],
      tableTitle: [
        {checked: true, prop: 'createTime', label: '进/出仓日期', "width": 120},
        {checked: true, prop: 'projectName', label: '项目名称', "min-width": 190},
        {checked: true, prop: 'orderCode', label: '进仓编号/出仓编号/提单号', "width": 240},
        {checked: true, prop: 'CNYProfit', label: '人民币利润', "width": 140},
        {checked: true, prop: 'USDProfit', label: '美元利润', "width": 140},
      ],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      layout: 'jumper, prev, pager, next, sizes'
    };
  },
  components: {
    DropTable,
    PaginationTpl
  },
  created() {
    modifyNetTitle('进出仓利润统计列表')
    this.getTableData();
    this.initEnterExitWarehouseProjectData();
  },
  methods: {
    getPickDate(pick) {
      this.pickDate = pick
    },
    disabledDate(date) {
      const { minDate, maxDate } = this.pickDate
      if (minDate && !maxDate) {
        const diff = Math.abs(minDate.valueOf() - date.valueOf())
        // 日期选择范围不能大于一年
        if (diff > 1000 * 3600 * 24 * 365) {
          return true
        }
      }
    },
    pickerBlur(val) {
      this.pickDate = '' // 清空getPickDate获取的数据
    },

    //获取进出仓利润统计列表
    getTableData() {
      let pageNo = this.currentPage;
      let pageSize = this.pageSize;
      let balancedType = this.screen.status;
      let type = this.screen.type;
      let projectId = this.screen.projectId;
      let beginDate = this.screen.date[0]?this.screen.date[0]:''
      let endDate = this.screen.date[1]?this.screen.date[1]:''
      let data = {
        pageNo,
        pageSize,
        balancedType,
        type,
        projectId,
        beginDate,
        endDate
      }
      Profit.getProfitList(data).then(res => {
        if (res.success) {
          let tableData = [];
          this.pageSize = res.result.pageSize;
          this.total = res.result.totalNum;
          res.result.items.map((value, index) => {
            let obj = {};
            obj.id = `${value.orderId}-${index+1}`;
            obj.orderId = value.orderId;
            obj.projectId = value.projectId;
            obj.projectName = value.projectName;
            obj.orderCode = value.orderCode;
            obj.createTime =  value.orderDate ? formatTimeToDate(value.orderDate): '';
            obj.CNYProfit = keepTwoDecimal(value.cnyReceivableAmount + value.cnyPayableAmount);
            obj.USDProfit = keepTwoDecimal(value.usdReceivableAmount + value.usdPayableAmount);
            tableData.push(obj);
          });
          this.tableData = tableData;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    getKey(row) {
      return row.id
    },

    onScreen() {
      this.currentPage = 1;
      this.getTableData();
    },

    //翻页
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.getTableData();
    },

    onSizeChange(data) {
      this.pageSize = data.pageSize;
      this.getTableData();
    },
    
    downExcel() {
      let balancedType = this.screen.status;
      let type = this.screen.type;
      let projectId = this.screen.projectId;
      let beginDate = this.screen.date[0]?this.screen.date[0]:''
      let endDate = this.screen.date[1]?this.screen.date[1]:''
      let data = {
        balancedType,
        type,
        projectId,
        beginDate,
        endDate
      }
      Profit.getExportExcel(data).then(res => {
        let blob = new Blob([res.data], { type: res.headers.contentType });
        let fileName = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        // 释放之前创建的URL对象
        window.URL.revokeObjectURL(url);
      })
    }
  }
};
</script>
<style lang="scss">
.profit {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
  .profit-search {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    .screen {
      display: flex;
      .w200 {
        width: 200px;
        margin-right: 16px;
      }
      .w240 {
        width: 240px;
        margin-right: 16px;
      }
    }
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 16px;
  }
  
  .el-checkbox__input.is-focus .el-checkbox__inner,
  .el-checkbox__inner:hover {
    border-color: #2E68EA;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner, 
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #2E68EA;
    border-color: #2E68EA;
  }
}
</style>
